import layout from "@/layouts/dashboard";

export default [
    {
        path: "/dashboard/security",
        name: "security",
        component: layout,
        redirect: {
            name: "dashboard-security-log",
        },
        children: [
            // 日志审计
            {
                path: "log/:type(\\w+)?",
                name: "dashboard-security-log",
                component: () => import("@/views/security/log"),
                meta: {
                    titleKey: "common.routes.logTitle",
                    descKey: "common.routes.logDesc",
                },
            },
            // 设备管理
            {
                path: "device",
                name: "dashboard-security-device",
                component: () => import("@/views/security/device"),
                meta: {
                    titleKey: "common.routes.deviceTitle",
                    descKey: "common.routes.deviceDesc",
                },
            },
            // 修改密码
            {
                path: "password",
                name: "dashboard-security-password",
                component: () => import("@/views/security/password"),
                meta: {
                    titleKey: "common.routes.passwordTitle",
                    descKey: "common.routes.passwordDesc",
                },
            },
            // 注销账号
            {
                path: "destroy",
                name: "dashboard-security-destroy",
                component: () => import("@/views/security/destroy"),
                meta: {
                    titleKey: "common.routes.destroyTitle",
                    descKey: "common.routes.destroyDesc",
                },
            },
        ],
    },
];
